import { useCallback, useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { DixaLanguage, DixaCountry, useDixa } from '@devsbb/dixa-sdk';

import { User } from 'ggApp/types/graphql';
import { ActiveStore } from 'ggApp/modules/store/selectors';

import { getDixaHMAC } from './getDixaHMAC';

interface EnhancedProps {
    activeStore: ActiveStore;
    isLoggedIn: boolean;
    user: User;
}

const Dixa = ({ user, activeStore, isLoggedIn }: EnhancedProps) => {
    const dixa = useDixa();
    const [token, setToken] = useState<string | undefined>();

    const getUserHmac = useCallback(async () => {
        if (!isLoggedIn || !user?.id) return;
        const response = await getDixaHMAC({ userId: user?.id });
        setToken(response);
    }, [user, isLoggedIn]);

    useEffectOnce(() => {
        dixa.load();

        return () => {
            dixa.shutdown();
        };
    });

    useEffect(() => {
        if (!activeStore.activeLanguage || !activeStore.country_code) {
            return;
        }

        dixa.init({
            language: activeStore.activeLanguage as DixaLanguage,
            country: activeStore.country_code.toLowerCase() as DixaCountry,
            hideToggler: true,
        });
    }, [dixa, activeStore]);

    useEffect(() => {
        getUserHmac();
    }, [user, isLoggedIn, getUserHmac]);

    useEffect(() => {
        if (isLoggedIn && token) {
            dixa.setUser({ type: 'verified', payload: { type: 'jwe', token } });
        }
    }, [isLoggedIn, token, dixa]);

    return null;
};

export default Dixa;
